<!--  <pre>data: {{ data|async|json }}</pre>-->
<ng-container *ngIf="showCard && !showInModal; else noCardView">
  <app-card [cardClasses]="'mt-7'" [header]="true" cardBodyClasses="pt-0" cardHeaderTitle="Ringkasan Harga">
    <ng-container cardBody>
      <ng-container [ngTemplateOutlet]="(isLoading | async) ? loaderTpl : dataCardTpl"></ng-container>
    </ng-container>
  </app-card>
</ng-container>

<ng-template #dataCardTpl>
  <ng-container *ngIf="data | async as data">
    <div class="px-4 py-6 border-bottom">
      <div class="d-flex font-14 justify-content-between">
        <p class="text-capitalize fw-bold mb-0">Metode Pembayaran</p>
        <p class="text-capitalize fw-bold mb-0">{{ data.payment_method_string }}</p>
      </div>
    </div>

    <div class="px-4 py-6 border-bottom" *ngIf="!!data.product_invoice_list.length">
      <ng-container *ngFor="let item of data.product_invoice_list; let i = index">
        <div class="mb-5 font-14">
          <div class="d-flex justify-content-between text-gray-900">
            <p class="">
              <span>{{ item.product_name }} {{ item.description }}</span>
            </p>
            <p class="">{{ utilities.toRupiah(item.total_base_price) }}</p>
          </div>
          <div *ngIf="item.discount_list && !!item.discount_list.length" class="text-gray-900 font-12">
            <div *ngFor="let discount of item.discount_list" class="d-flex justify-content-between">
              <p class="ms-3">{{ discount.name }}</p>
              <p class="text-danger">-{{ utilities.toRupiah(discount.price) }}</p>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="d-flex justify-content-between font-14 text-gray-900">
        <p class="text-capitalize fw-bold mb-0">Subtotal</p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(data.subtotal_invoice) }}</p>
      </div>
    </div>

    <!-- CBD DISCOUNT SECTION -->
    <div *ngIf="!!data.discount_list.length" class="px-4 py-6 border-bottom">
      <div *ngFor="let discount of data.discount_list" class="d-flex justify-content-between font-14 text-gray-900">
        <p class="mb-0">{{ discount.name }}</p>
        <p class="mb-0 text-danger">-{{ utilities.toRupiah(discount.price) }}</p>
      </div>
    </div>

    <div class="px-4 py-6">
      <div class="d-flex font-14 justify-content-between">
        <p class="fw-bold mb-0">Total Harga <span class="text-gray-600 fw-normal">(Include PPN)</span></p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(data.total_invoice) }}</p>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #noCardView>
  <ng-container *ngIf="dataValue as data">
    <div class="px-4 py-6 border-bottom">
      <div class="d-flex font-14 justify-content-between">
        <p class="text-capitalize fw-bold mb-0">Metode Pembayaran</p>
        <p class="text-capitalize fw-bold mb-0">{{ data.payment_method_string }}</p>
      </div>
    </div>

    <div class="px-4 py-6 border-bottom">
      <ng-container *ngFor="let item of data.product_invoice_list; let i = index">
        <div class="mb-5 font-14">
          <div class="d-flex justify-content-between text-gray-900">
            <p class="">
              <span>{{ item.product_name }} {{ item.description }}</span>
            </p>
            <p class="">{{ utilities.toRupiah(item.total_base_price) }}</p>
          </div>
          <div *ngIf="item.discount_list.length > 0" class="text-gray-900 font-12">
            <div *ngFor="let discount of item.discount_list" class="d-flex justify-content-between">
              <p class="ms-3">{{ discount.name }}</p>
              <p class="text-danger">-{{ utilities.toRupiah(discount.price) }}</p>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="data.subtotal_invoice" class="d-flex justify-content-between font-14 text-gray-900">
        <p class="text-capitalize fw-bold mb-0">Subtotal</p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(data.subtotal_invoice) }}</p>
      </div>
    </div>

    <!-- CBD DISCOUNT SECTION -->
    <div *ngIf="data.discount_list.length > 0" class="px-4 py-6 border-bottom">
      <div *ngFor="let discount of data.discount_list" class="d-flex justify-content-between font-14 text-gray-900">
        <p class="mb-0">{{ discount.name }}</p>
        <p class="mb-0 text-danger">-{{ utilities.toRupiah(discount.price) }}</p>
      </div>
    </div>

    <div *ngIf="data.total_invoice" class="px-4 py-6">
      <div class="d-flex font-14 justify-content-between">
        <p class="fw-bold mb-0">Total Harga <span class="text-gray-600 fw-normal">(Include PPN)</span></p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(data.total_invoice) }}</p>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loaderTpl>
  <div *ngFor="let item of Array.from([1, 2, 3])" class="mb-4">
    <div class="d-flex justify-content-between" *ngFor="let item of Array.from([1, 2]); let i = index; let first = first">
      <div><app-skeleton-text [count]="1" [width]="first ? 300 : 200" /></div>
      <div><app-skeleton-text [count]="1" /></div>
    </div>
  </div>
</ng-template>
